export default __webpack_public_path__ + "static/1-299facd28f3382770f37627d5dc8611d.jpeg";